import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
var PlayerContext = createContext(undefined);
PlayerContext.displayName = "PlayerContext";
export var usePlayerContext = function () {
    var context = useContext(PlayerContext);
    if (!context) {
        throw new Error("usePlayerContext must be used within a PlayerContextProvider");
    }
    return context;
};
export var PlayerContextProvider = function (_a) {
    var children = _a.children;
    var _b = useState("00000000-0000-0000-0000-000000000000"), sessionId = _b[0], setSessionId = _b[1];
    return (_jsx(PlayerContext.Provider, { value: { sessionId: sessionId, setSessionId: setSessionId }, children: children }));
};
//# sourceMappingURL=PlayerContext.js.map